import React from 'react';
import {
  HashRouter, Route, Switch, Redirect
} from 'react-router-dom';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

// components
import Layout from './Layout';

// pages
import Error from '../pages/error';
import Login from '../pages/login';

// context
import { useUserState } from '../context/UserContext';
import Boleto from '../pages/boleto';

export default function App() {
  // global
  const { isAuthenticated } = useUserState();

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <HashRouter>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/app/dashboard" />} />
          <Route
            exact
            path="/app"
            render={() => <Redirect to="/app/dashboard" />}
          />
          <PrivateRoute path="/app" component={Layout} />
          <PublicRoute
            path="/fatura/:nossoNumero"
            exact
            component={Boleto}
          />
          <PublicRoute path="/login" exact component={Login} />
          <PublicRoute path="/recuperar-senha/:token" exact component={Login} />
          <Route component={Error} />
        </Switch>
      </HashRouter>
    </MuiPickersUtilsProvider>
  );

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) => (isAuthenticated ? (
          React.createElement(component, props)
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: {
                from: props.location,
              },
            }}
          />
        ))}
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) => (isAuthenticated && rest.path !== '/fatura/:nossoNumero' ? (
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        ) : (
          React.createElement(component, props)
        ))}
      />
    );
  }
}
